import 'css-chunk:src/index/components/conflict_list/index.module.scss';export default {
  "container": "container__-6Ev1",
  "row": "row__2LjtK",
  "box1": "box1__XSwCp",
  "box2": "box2__WF5Gi",
  "item": "item__jw7fV",
  "mark": "mark__c94Sz",
  "status": "status__WJM6d",
  "selector": "selector__7csNz",
  "show": "show__u-2DH",
  "hint": "hint__W-yuz"
};